import {BehaviorSubject} from 'rxjs';

import UiEventType            from '../../Ui/Shared/Constants/UiEventType';
import IUiEventsStreamPayload from '../../Ui/Shared/Interfaces/IUiEventsStreamPayload';
import IEventBinding          from '../Interfaces/IEventBinding';
import Player                 from '../Player';

const bindRootFocusEvent = (player: Player): IEventBinding => {
    const handler = (): void => (player.ui.uiEvents$ as BehaviorSubject<IUiEventsStreamPayload>)
        .next({
            type: UiEventType.FRAME_FOCUS
        });

    const {root} = player.refs;

    root.addEventListener('focus', handler);

    const release = () => root.removeEventListener('focus', handler);

    return {
        release
    };
};

export default bindRootFocusEvent;